/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */

export type MissionOutcome = typeof MissionOutcome[keyof typeof MissionOutcome];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MissionOutcome = {
  FoundAlive: 'FoundAlive',
  FoundDeceased: 'FoundDeceased',
  StrandedRescued: 'StrandedRescued',
  SearchCancelled: 'SearchCancelled',
  FoundByAnotherParty: 'FoundByAnotherParty',
  HandedToAuthorities: 'HandedToAuthorities',
  ReturnedByThemselves: 'ReturnedByThemselves',
} as const;
